import rules from './rules'
import * as yup from 'yup'

/**
 * Extends yup base schemas with new methods.
 * @see https://www.npmjs.com/package/yup
 */
yup.addMethod(yup.string, 'cpf', rules.string.cpf)
yup.addMethod(yup.string, 'name', rules.string.name)
yup.addMethod(yup.string, 'cnpj', rules.string.cnpj)
yup.addMethod(yup.string, 'phone', rules.string.phone)

/**
 * Initializes yup internationalization dictionary with i18n custom keys.
 * @see https://www.npmjs.com/package/yup
 * @see https://dev.to/adrai/how-to-properly-internationalize-a-react-application-using-i18next-3hdb
 * @todo Apply i18n to this dictionary and move to a key-value-based approach.
 */
yup.setLocale({
  mixed: {
    required: ({ label }) => ({ key: 'required_field', values: { label } })
  },
  string: {
    email: 'Digite um e-mail válido.',
    min: ({ min }) => ({
      key: min >= 1 ? 'min_characters' : 'min_one_character',
      values: { min }
    }),
    max: ({ max }) => ({
      key: max >= 1 ? 'max_one_character' : 'max_one_character',
      values: { max }
    })
  }
})

export default yup
